var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"mr-auto",style:({ 'background-color': _vm.backgroundColor }),attrs:{"src":_vm.src,"width":"150","contain":"","aspect-ratio":7 / 3}})
}
var staticRenderFns = []

export { render, staticRenderFns }